<template>
    <div>
        <div class="card-mod" :class="{'card-mod': true,'none': !showcard || info.user_info.mp_rank < 3}">
            <div class="card-bg bg1" :class="{'card-bg': true,'bg1': info.card.style == '1','bg2': info.card.style == '2','bg3': info.card.style == '3'}">
                <span><cite>{{info.card.card_name}}</cite><img v-if="info.card.flag_picture" :src="getflagurl(info.card.flag_picture)" /></span>
            </div>
            <div class="card-info">
                <div class="position" :class="{'position': true,'none': !info.card.city_name}">
                <i class="icon i_add2"></i>
                <cite class="city">{{info.card.city_name}}</cite>
                </div>
                <div :class="{'author-follow': true,'icon': true,'i_unfollow': is_followed,'followed': is_followed,'none': !show_follow}"></div>
                <div class="author-desc">
                <div class="author-me">
                    <div class="face"><img :src="changeUserImgUrls(info.user_info && info.user_info.avatar)" /></div>
                    <template v-if="info.user_info">
                        <template v-if="info.user_info.mp_rank * 1 > 0">
                            <div class="level"><img :src="authorlevelurl + info.user_info.mp_rank + '.png'" /></div>
                        </template>
                        <template v-else-if="info.user_info.anchor_status == 1">
                            <div class="level"><img :src="anchorurl" /></div>
                        </template>
                    </template>
                </div>
                    <div class="name">
                        <strong>
                            <template v-if="info.user_info && info.user_info.nickname">
                                {{info.user_info.nickname}}
                            </template>
                        </strong>
                        <template v-if="info.user_info && info.user_info.level == '1'">
                            <img class="vip" src="https://s.jihaimall.com/h5/image/v.png" />
                        </template>
                    </div>
                    <div class="say">{{info.user_info && info.user_info.intro}}</div>
                    <div class="desc" v-html="deschtml"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getAppV, getVersionNotApp, changeUserImgUrl } from "../../utils/base"
export default {
    name: "Card",
    props: ["info", "is_followed", "show_follow", "isHiscores", "parent"],
    data () {
        return {
            authorlevelurl: "https://s.jihaimall.com/h5/image/userlebal/authorlevel",
            anchorurl: "https://s.jihaimall.com/h5/image/userlebal/anchorlogo.png",
            showcard: 1,
            identity_split: "即嗨号自媒体专家",
            deschtml: "",
            country_pic: ""
        }
    },
    mounted () {
        this.initIdentity()
        this.inInt()
    },
    methods: {
        changeUserImgUrls (img) {
            return changeUserImgUrl(img)
        },
        getflagurl (imgurl) {
            if (imgurl.indexOf("@") > 0) {
                return imgurl;
            } else if (imgurl.indexOf("img0.jihai8.com") > 0) {
                return imgurl + "@!flag";
            }
            return imgurl;
        },
        initIdentity () {
            if ((getAppV() && getAppV() >= 330) || (getVersionNotApp() && getVersionNotApp() >= 330)) {
                this.identity_split = "即嗨号自媒体专家";
            } else {
                this.identity_split = "即嗨号自媒体作者";
            }
        },
        inInt () {
            let card = this.info.card
            if (!card) {
                this.showcard = 0;
                card = {}
            } else {
                if (this.isHiscores && card.card_name === '即嗨号自媒体作者') {
                    card.card_name = '专家号自媒体作者';
                } else {
                    card.card_name = this.identity_split;
                }
            }
            if (card.introduce) {
                this.deschtml = '<p>' + card.introduce.replace(/\n/g, '</p><p>') + '</p>';
            } else {
                this.showcard = 0;
            }
        }
    }
}
</script>
